const { classifySku, sortSkuCatalogue, isSkuAutoSelectableForCarType } = require('@/utils/carTypeInsuranceSku');

module.exports = {
  data() {
    return { manualInsurancePickerKey: 0, manualInsurancePromptOpen: false, expressInsuranceUnavailable: null };
  },
  computed: {
    automaticInsuranceProducts() {
      const list = this.$store.state.list;
      return this.list_insurance.third_insurance_product.filter(product =>
        isSkuAutoSelectableForCarType(list.car_type_insurance_sku,
          list.car_type_insurance_sku_loaded, this.form.car_type, product.sku_code, this.form.car_fuel));
    },
    sortedManualInsuranceProducts() {
      const list = this.$store.state.list;
      // Sort a copy for display only. Existing refresh/automatic selection uses
      // the original catalogue order and unchanged product objects.
      return sortSkuCatalogue(this.list_insurance.third_insurance_product,
        list.car_type_insurance_sku, list.car_type_insurance_sku_loaded, this.form.car_type, this.form.car_fuel);
    },
  },
  methods: {
    manualInsuranceClassification(product) {
      const list = this.$store.state.list;
      return classifySku(list.car_type_insurance_sku, list.car_type_insurance_sku_loaded,
        this.form.car_type, product.sku_code, this.form.car_fuel);
    },
    manualInsuranceLabel(product) {
      const labels = { RECOMMENDED: 'แนะนำตามประเภทรถ', SPECIAL: 'ตรวจสอบเงื่อนไขเพิ่มเติม', OTHER: 'อาจไม่ตรงกับประเภทรถ' };
      return `${product.sku_code} ${product.sku_detail || ''} (${labels[this.manualInsuranceClassification(product)]})`;
    },
    async selectManualInsurance(product) {
      // Clearing search text is not a product choice. Remounting here would
      // close the menu and prevent browsing the complete catalogue.
      if (!product) return;
      if (this.manualInsurancePromptOpen) {
        this.manualInsurancePickerKey++;
        return;
      }
      const before = JSON.stringify(this.form);
      const classification = this.manualInsuranceClassification(product);
      if (classification !== 'RECOMMENDED') {
        this.manualInsurancePromptOpen = true;
        const types = this.$store.state.list.car_type_dict || [];
        const type = types.find(row => row.value === this.form.car_type);
        let decision;
        const escapeHtml = (value) => String(value || '')
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#39;');

        try {
          decision = await this.$alertConfirm({
            title: classification === 'OTHER'
              ? 'รหัส พ.ร.บ. อาจไม่ตรง กับประเภทรถ'
              : 'โปรดตรวจสอบเงื่อนไข พ.ร.บ.',

            html: `
              ${escapeHtml(type ? type.name : '')}<br>
              กับ<br>
              ${escapeHtml(product.sku_code)} ${escapeHtml(product.sku_detail)}<br>
              ${classification === 'OTHER'
                ? 'อาจไม่ตรงกับประเภท หรือ ลักษณะการใช้รถ โปรดตรวจสอบ'
                : 'ยังยืนยันความเหมาะสมไม่ได้ โปรดตรวจสอบเงื่อนไขเพิ่มเติม'}
            `,

            confirmButtonText: 'ยืนยันใช้รหัสนี้',
            cancelButtonText: 'กลับไปเลือกใหม่',
            timer: false,
          });
        } finally {
          this.manualInsurancePromptOpen = false;
          this.manualInsurancePickerKey++;
        }
        if (!decision || !decision.isConfirmed || JSON.stringify(this.form) !== before) return;
      }
      // Only this UI event is advisory-gated. Hydration and automatic flows
      // continue to call the existing setters directly.
      if (this.setThirdInsuranceForm) await this.setThirdInsuranceForm(product);
      else await this.filterAndSetThirdInsuranceForm(product);
    },
  },
};
